import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import 'normalize.css'
import { PersistGate } from 'redux-persist/integration/react'
import App from './App'
import * as serviceWorker from './registerServiceWorker'
import './index.css'
import * as Sentry from '@sentry/react'
import { PROD } from 'Config'
import { store, persistor } from './store.index'
import Clarity from '@microsoft/clarity'
import { inIframe } from './utils/helper'

const is_in_iframe = inIframe()

Clarity.init('qcoatnthm3')
if (is_in_iframe) {
  Clarity.consent(false)
}

Sentry.init({
  enabled: true,
  dsn:
    'https://96dd88f36a184aa8a37c2d5d226b4b78@o443412.ingest.sentry.io/5454988',
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0,
  environment: PROD ? 'production' : 'development',
  ignoreErrors: ['Non-Error promise rejection captured', 'Loading chunk'],
  autoSessionTracking: true
})

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register()
